import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '../../hooks/useAuth'
import { useImagenesPublicacion } from '../../hooks/useImagenesPublicacion.js'
import { resetCategorias, setBusca } from '../../slices/filterSlice'
import { PublicacionSinDetalle } from '../reutilizables/publicacionSinDetalle/PublicacionSinDetalle'
import { obtenerPublicaciones } from '../servicios/publicacionesService'
import LinkButton from '../ui/LinkButton'
import styles from './CabeceraBuscador.module.css'

const BUSCADOR_DELAY_MS = 1000

const CabeceraBuscador = () => {
  const { loginDataContext: { idUsuario, empid } = {} } = useAuth()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [results, setResults] = useState([])
  const [showResults, setShowResults] = useState(false)
  const [searchValue, setSearchValue] = useState('')

  const timeoutRef = useRef(null)
  const containerRef = useRef(null)
  const { adjuntos, loadingImagenes, fetchImagenes } = useImagenesPublicacion()

  const { busca } = useSelector((state) => state.filters)

  const handleInput = (e) => {
    const value = e.target.value
    setSearchValue(value)
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    if (!value) {
      setResults([])
      setShowResults(false)
      return
    }
    timeoutRef.current = setTimeout(async () => {
      const data = (await obtenerPublicaciones(idUsuario, 0, 0, value, empid)).data.body

      const publicacionesFiltradas = data.filter((p) => p.empid !== empid)

      setResults(
        publicacionesFiltradas.length ? publicacionesFiltradas : [`No hay resultados para ${value}`]
      )
      setShowResults(true)
    }, BUSCADOR_DELAY_MS)
  }

  useEffect(() => {
    if (results.length > 0) {
      const idPublicaciones = results
        .filter((p) => p && typeof p === 'object' && p.idPublicacion)
        .map((p) => p.idPublicacion)
      fetchImagenes({
        idPublicaciones
      })
    }
  }, [results])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowResults(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  useEffect(() => {
    setSearchValue(busca)
  }, [busca])

  return (
    <div className={`${styles.buscadorBox} box`} ref={containerRef}>
      <div className={styles.containerBuscador}>
        <form
          id="formCabeceraBuscador"
          onSubmit={(event) => {
            event.preventDefault()
            if (timeoutRef.current) {
              clearTimeout(timeoutRef.current)
              timeoutRef.current = null
            }
            setShowResults(false)
            setResults([])
            dispatch(resetCategorias())
            dispatch(setBusca(searchValue))
            if (location.pathname !== '/PublicacionesOfertas') {
              navigate('/Publicaciones')
            }
          }}
        >
          <input
            type="text"
            id="search"
            autoComplete="off"
            placeholder="Buscar publicaciones..."
            value={searchValue}
            onChange={(e) => handleInput(e)}
            onClick={() => searchValue && setShowResults(true)}
          />
          <LinkButton className={styles.buscadorIcon} type="submit">
            <i className="fa fa-search" aria-hidden="true" />
          </LinkButton>
        </form>
      </div>

      {showResults && results.length > 0 && (
        <div className={styles.buscadorResultados}>
          {results[0]?.idPublicacion && (
            <p className={styles.buscadorResultadosTitulo}>Resultados de la búsqueda</p>
          )}
          {results.map((publicacion) =>
            publicacion.idPublicacion ? (
              <div
                key={publicacion.idPublicacion}
                className={styles.buscadorItem}
                onClick={() => {
                  setShowResults(false)
                  setResults([])
                  setSearchValue('')
                  navigate(`/Publicacion/${publicacion.idPublicacion}`)
                }}
              >
                <PublicacionSinDetalle
                  publicacion={publicacion}
                  adjunto={adjuntos.find((a) => a.idPublicacion === publicacion.idPublicacion)}
                  loadingImagenes={loadingImagenes}
                />
              </div>
            ) : (
              <p key={publicacion} className={styles.buscadorSinResultados}>
                {publicacion}
              </p>
            )
          )}
        </div>
      )}
    </div>
  )
}

export default CabeceraBuscador
